"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopupSelector = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _getPrefixCls = require("../../../utils/getPrefixCls");
var _Button = require("../../Button");
var _Popup = require("../../Popup");
var _clsx2 = _interopRequireDefault(require("clsx"));
var PopupSelector = function PopupSelector(props) {
  var _props$value, _props$value2;
  var popup = props.popup,
    options = props.options;
  var onButtonClick = function onButtonClick(option) {
    var _props$onChange, _props$popup, _props$popup$onClose;
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, option);
    (_props$popup = props.popup) === null || _props$popup === void 0 ? void 0 : (_props$popup$onClose = _props$popup.onClose) === null || _props$popup$onClose === void 0 ? void 0 : _props$popup$onClose.call(_props$popup);
  };
  var PREFIX = (0, _getPrefixCls.getPrefixCls)('popup-selector');
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)("".concat(PREFIX, "-name"), (0, _defineProperty2.default)({}, "".concat(PREFIX, "-name__prompt"), !((_props$value = props.value) !== null && _props$value !== void 0 && _props$value.content)))
  }, ((_props$value2 = props.value) === null || _props$value2 === void 0 ? void 0 : _props$value2.content) || 'Select'), /*#__PURE__*/_react.default.createElement(_Popup.Popup, (0, _extends2.default)({
    showCloseIcon: true
  }, popup), options.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_Button.Button, {
      key: option.value,
      type: "text",
      text: option.content,
      onClick: function onClick() {
        return onButtonClick(option);
      },
      trackingData: props.trackingData,
      componentData: {
        content: option.content
      }
    });
  })));
};
exports.PopupSelector = PopupSelector;